import {CommonModule} from "@angular/common";
import {Component, Input, NgModule} from '@angular/core';
import {translateString, TranslatedString} from "./translation-helper";

@Component({
    selector: 'lib-translated-string',
    template: `{{ translated }}`,
})
export class TranslatedStringComponent {
    @Input() translation: TranslatedString | undefined
    @Input() fallbackLanguage = 'en';

    public info = ''

    get translated(): string | undefined {
        return translateString(this.translation, this.fallbackLanguage);
    }
}

@NgModule({
    declarations: [TranslatedStringComponent],
    imports: [CommonModule],
    exports: [TranslatedStringComponent]
})
export class TranslatedStringModule {
}